<template>
  <el-container class="bg-gray-100 h-screen p-0">
    <!-- Зүүн талын Sidebar -->
    <el-aside class="w-64 bg-gray-900 text-white" style="background-color: #2a2a2e; padding: 0;">
      <el-menu
        :default-active="activeMenu"
        class="el-menu-vertical-demo"
        unique-opened
        background-color="#2a2a2e"
        text-color="#fff"
        active-text-color="#ffd04b">
        <template v-for="(item, index) in menu">
          <!-- Хэрэв header төрөл бол -->
          <el-menu-item
            v-if="item.header"
            :key="'header-' + index"
            index="header"
            disabled
            class="font-bold cursor-default">
            {{ item.title }}
          </el-menu-item>
          <!-- Хэрэв олон дэд цэстэй бол -->
          <el-submenu
            v-else-if="item.child && item.child.length"
            :key="'submenu-' + index"
            :index="item.title">
            <template slot="title">
              <i :class="item.icon"></i>
              <span>{{ item.title }}</span>
            </template>
            <el-menu-item
              v-for="(child, idx) in item.child"
              :key="'child-' + idx"
              :index="child.href"
              @click="handleMenuSelect(child.href)">
              <i :class="child.icon"></i>
              <span>{{ child.title }}</span>
            </el-menu-item>
          </el-submenu>
          <!-- Шууд линк бол -->
          <el-menu-item
            v-else
            :key="'item-' + index"
            :index="item.href"
            @click="handleMenuSelect(item.href)">
            <i :class="item.icon"></i>
            <span>{{ item.title }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </el-aside>

    <!-- Гол -->
    <el-container>
      <el-header class="bg-white flex justify-between items-center shadow-md h-12 px-4">
        <b class="text-gray-800">{{ username }}</b>
        <el-button size="small" @click="signOut" type="info" class="bg-blue-500 text-white px-3 py-1 rounded-md hover:bg-blue-600">Гарах</el-button>
      </el-header>
      <el-main class="p-4">
        <router-view/>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { signOut, getUserName, getEmail, getGroups } from '@/utils/auth.js'

export default {
  data () {
    return {
      username: 'username',
      activeMenu: '',
      menu: [
        {
          header: true,
          title: 'ТОКТОК',
          hiddenOnCollapse: true,
          showOneChild: true
        },
        {
          title: 'Dashboard',
          icon: 'el-icon-data-analysis',
          child: [
            {
              href: '/settlementDashboard',
              title: 'Харилцагчийн тооцоо',
              icon: 'el-icon-office-building'
            },
            {
              href: '/couponDashboard',
              title: 'Купон',
              icon: 'el-icon-discount'
            }
          ]
        },
        {
          title: 'Тооцоо нийлэх',
          icon: 'el-icon-s-data',
          child: [
            {
              href: '/settlement-list',
              title: 'Харилцагчийн тооцоо',
              icon: 'el-icon-bank-card'
            },
            {
              href: '/settlementlist-driver',
              title: 'Жолоочийн тооцоо',
              icon: 'el-icon-user'
            },
            {
              href: '/settlement-act',
              title: 'Тооцоо нийлсэн акт',
              icon: 'el-icon-document'
            }
          ]
        },
        {
          title: 'Купон',
          icon: 'el-icon-s-ticket',
          href: '/discount-list'
        }
      ]
    }
  },
  created () {
    this.initializeUser()
    this.filterMenu()
    this.activeMenu = this.$route.path
  },
  watch: {
    '$route.path' (newPath) {
      this.activeMenu = newPath
    }
  },
  methods: {
    async signOut () {
      await signOut()
    },
    async initializeUser () {
      this.username = await getUserName()
      this.$root.username = await getUserName()
      this.$root.email = await getEmail()
    },
    filterMenu () {
      getGroups().then((response) => {
        this.group = response
        if (!response.includes('boss') && !response.includes('accountant') && !response.includes('view')) {
          // "Тооцоо нийлэх" цэсийг устгах
          this.menu = this.menu.filter(item => item.title !== 'Тооцоо нийлэх')
        }
      })
    },
    handleMenuSelect (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style scoped>
.el-header {
  background-color: #ffffff;
  color: #333;
}
.el-aside {
  background-color: #fff;
  color: #333;
  height: 100vh;
}
</style>
